<div class="ui-recaptcha-wrap" #wrap>
  <div
    #host
    class="ui-recaptcha"
    [attr.aria-busy]="!isReady() ? 'true' : null"
    aria-label="Verificación reCAPTCHA"
  ></div>
</div>
